module.exports = __webpack_public_path__ + "assets/90122dda38df284fc0a0e4e1abb1b6e2.png";